<form class="part-input-form">
  <div class="dialogContainer">
    <div class="header">
      <h2>{{ isAddQuote() ? "Create Parts Quote" : "Add Parts To " + entity.id.entityId + ";" + entity.id.entityRevision }}</h2>
    </div>
    <div class="content">
      <div>
        @if (userProjectProductTypes().length > 1) {
          <select name="projectTypeSelection" class="pptSelection" [(ngModel)]="determinedPPT" (ngModelChange)="determinedPPTChanged()">
            <option value="undefined" disabled>Select Project Type</option>
            @for (ppt of userProjectProductTypes(); track ppt) {
              <option [ngValue]="ppt">
                {{ ppt === ProjectProductType.RES ? "Residential" : "Commercial" }}
              </option>
            }
          </select>
        }
        <input
          class="standardTextBox searchInput"
          placeholder="Search by serial, model or part number"
          [formControl]="partSearchTermInputControl"
          (keyup)="handleKeyUp($event)"
          [matAutocomplete]="auto" />
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
          @for (option of filteredOptions() | async; track option) {
            <mat-option [value]="option">{{ option.description }}</mat-option>
          }
        </mat-autocomplete>
        @if (warrantyAvailable()) {
          <label for="warrantyCheckBox">Warranty</label>
        }
        @if (warrantyAvailable()) {
          <input class="checkboxInput" type="checkbox" id="warrantyCheckBox" name="isWarrantyInput" [(ngModel)]="warranty" (click)="warrantyChanged()" />
        }
        <button [disabled]="!this.partSearchTermInputControl.value || this.partSearchTermInputControl.value.length < 3" class="standardButton" (click)="search()">Search</button>
        <span class="spacer"></span>
        <span>
          <button matButton="text" (click)="openHelpDialog()">
            <span>
              <mat-icon>help_outline</mat-icon>
            </span>
          </button>
        </span>
      </div>
      @if (partSerialInformation()) {
        <div class="partSerialInformationContainer">
          <table>
            <tr>
              <td class="headerCell tableCell">Model:</td>
              <td class="tableCell">{{ this.partSerialInformation().prdno }}</td>
              <td class="headerCell tableCell">Build Date:</td>
              <td class="tableCell">{{ this.partSerialInformation().built_date }}</td>
              <td class="headerCell tableCell">Install Date:</td>
              <td class="tableCell">{{ this.partSerialInformation().install_date }}</td>
            </tr>
            <tr>
              <td class="headerCell tableCell">Serial #:</td>
              <td class="tableCell">{{ this.partSerialInformation().serial }}</td>
              <td class="headerCell tableCell">Sales Order:</td>
              <td class="tableCell">{{ this.partSerialInformation().ordno }}</td>
              <td class="headerCell tableCell">Shipped Date:</td>
              <td class="tableCell">{{ this.partSerialInformation().pick_date }}</td>
            </tr>
          </table>
        </div>
      }
      <mat-dialog-content class="noScrollBar">
        @if (searchResult(); as searchResult) {
          <mat-tab-group [(selectedIndex)]="tabIndex">
            <mat-tab label="Parts">
              <div class="tableContainer">
                <table id="partTable" class="resultTable">
                  <thead>
                    <tr>
                      <td class="headerCell tableCell">Part #</td>
                      <td class="headerCell tableCell">Description</td>
                      <td class="headerCell tableCell">Available</td>
                      <td class="headerCell tableCell">Price</td>
                      <td class="headerCell tableCell">Quantity</td>
                      <td class="headerCell tableCell">Related</td>
                      <td class="headerCell tableCell">Replacement</td>
                    </tr>
                  </thead>
                  @for (part of searchResult.parts; track part) {
                    <tr [ngClass]="{ partWithinPart: part.partWithinPartSearch }">
                      <td class="tableCell">
                        <span class="fakeLink" (click)="openIndividualPartsDialog(part)">{{ part.partNumber }}</span>
                      </td>
                      <td class="tableCell">{{ part.description }}</td>
                      <td class="tableCell">{{ part.available }}</td>
                      <td class="tableCell rightAligned">{{ part.price | currency: "USD" }}</td>
                      <td class="tableCell"><input class="quantityInput" name="partQuantityInput" [(ngModel)]="part.quantity" /></td>
                      <td class="tableCell">
                        @if (part.relatedParts && part.relatedParts.length > 0) {
                          <span class="fakeLink" (click)="openIndividualPartsDialog(part)">Y</span>
                        }
                        @if (!part.relatedParts || part.relatedParts.length == 0) {
                          <span>N</span>
                        }
                      </td>
                      <td class="tableCell">
                        @if (part.replacementText && part.replacementText.length > 0) {
                          <span class="fakeLink" (click)="openIndividualPartsDialog(part)">Y</span>
                        }
                        @if (!part.replacementText || part.replacementText.length == 0) {
                          <span>N</span>
                        }
                      </td>
                    </tr>
                  }
                </table>
              </div>
            </mat-tab>
            @if (warranty() && partSerialInformation() && searchResult) {
              <mat-tab label="Information" [labelClass]="passesWarrantyFieldsTests() ? '' : 'information-tab'">
                <div class="tableContainer">
                  <table class="resultTable informationTable">
                    @if (!partSerialInformation().install_date) {
                      <tr>
                        <td class="headerCell tableCell informationLabel">Install Date:</td>
                        <td class="tableCell informationContent">
                          <input [matDatepicker]="installDatepicker" name="installDateInput" [(ngModel)]="searchResult.installDate" />
                          <mat-datepicker-toggle matIconSuffix [for]="installDatepicker"></mat-datepicker-toggle>
                          <mat-datepicker #installDatepicker></mat-datepicker>
                        </td>
                      </tr>
                    }
                    <tr>
                      <td class="headerCell tableCell informationLabel">Defect Code:</td>
                      <td class="tableCell informationContent">
                        <select class="inputField" name="defectCodeInput" [(ngModel)]="searchResult.defectCodeId">
                          @for (defectCode of this.defectCodes(); track defectCode) {
                            <option [ngValue]="defectCode.id">
                              {{ defectCode.description }}
                            </option>
                          }
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td class="headerCell tableCell informationLabel">Miles:</td>
                      <td class="tableCell informationContent">
                        <select class="inputField" name="milesInput" [(ngModel)]="searchResult.miles">
                          @for (selectionItem of this.miles; track selectionItem) {
                            <option [ngValue]="selectionItem.code">
                              {{ selectionItem.description }}
                            </option>
                          }
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td class="headerCell tableCell informationLabel">Failure Date:</td>
                      <td class="tableCell informationContent">
                        <input [matDatepicker]="failureDatePicker" name="failureDateInput" [(ngModel)]="searchResult.failureDate" [max]="today" />
                        <mat-datepicker-toggle [for]="failureDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker id="failureDatePicker" #failureDatePicker></mat-datepicker>
                      </td>
                    </tr>
                    <tr>
                      <td class="headerCell tableCell informationLabel"><label>Dealer Address:</label></td>
                      <td class="tableCell informationContent">
                        <span
                          class="addressSelection"
                          [ngClass]="{ 'select-disabled': addressSelectionDisabled() }"
                          (click)="selectAddress()"
                          [matTooltip]="'Only one dealer address can be used per quote.'"
                          [matTooltipDisabled]="!addressSelectionDisabled()">
                          {{ getDealerDescription() || "SELECT" }}
                        </span>
                      </td>
                    </tr>
                  </table>
                  <mat-form-field class="multi-line-input" hintLabel="Max 120 characters">
                    <mat-label>Warranty Notes</mat-label>
                    <textarea matInput [maxlength]="maxWarrantyTextLength" name="warrantyTextInput" rows="4" class="noresize" [(ngModel)]="warrantyRequestNotes"></textarea>
                    <mat-hint align="end">{{(warrantyRequestNotes?.length || 0) + '/' + maxWarrantyTextLength}}</mat-hint>
                  </mat-form-field>
                </div>
              </mat-tab>
            }
            @if (this.decoderData()) {
              <mat-tab label="Decoder">
                <decoder-table [decoderData]="this.decoderData()" [title]="'Decoder For ' + this.partSerialInformation().prdno"></decoder-table>
              </mat-tab>
            }
            @if (this.dealerConsumerInformation()) {
              <mat-tab label="Dealer/Consumer Information">
                <div class="tableContainer">
                  <table class="resultTable">
                    <tr>
                      <td class="headerCell center">Dealer Information</td>
                      <td class="headerCell center">Consumer Information</td>
                    </tr>
                    <tr>
                      <td class="tableCell">{{ this.dealerConsumerInformation().dealer }}</td>
                      <td class="tableCell">{{ this.dealerConsumerInformation().consumer }}</td>
                    </tr>
                    <tr>
                      <td class="tableCell">{{ this.dealerConsumerInformation().dealerAddress }}</td>
                      <td class="tableCell">{{ this.dealerConsumerInformation().consumerAddress }}</td>
                    </tr>
                    <tr>
                      <td class="tableCell">{{ this.dealerConsumerInformation().dealerCity }} , {{ this.dealerConsumerInformation().dealerState }}</td>
                      <td class="tableCell">{{ this.dealerConsumerInformation().consumerCity }} , {{ this.dealerConsumerInformation().consumerState }}</td>
                    </tr>
                    <tr>
                      <td class="tableCell">{{ this.dealerConsumerInformation().dealerCountry }} , {{ this.dealerConsumerInformation().dealerZip }}</td>
                      <td class="tableCell">{{ this.dealerConsumerInformation().consumerCountry }} , {{ this.dealerConsumerInformation().consumerZip }}</td>
                    </tr>
                  </table>
                </div>
              </mat-tab>
            }
            @if (
              (this.stdWarranties() && this.stdWarranties().length > 0) ||
              (this.extWarranties() && this.extWarranties().length > 0) ||
              (this.sewpWarranties() && this.sewpWarranties().length > 0)
            ) {
              <mat-tab label="Warranties">
                @if (this.stdWarranties() && this.stdWarranties().length > 0) {
                  <div class="tableContainer">
                    <table class="resultTable">
                      <thead>
                        <td class="headerCell center" colspan="7">STD Warranties</td>
                      </thead>
                      @for (warranty of this.stdWarranties(); track warranty) {
                        <tr>
                          <td class="tableCell">{{ warranty.warrantyTitle }}</td>
                          <td class="tableCell">{{ determineStdWarrantyDescription(warranty) }}</td>
                        </tr>
                      }
                    </table>
                  </div>
                }
                @if (this.extWarranties() && this.extWarranties().length > 0) {
                  <div class="tableContainer">
                    <table class="resultTable">
                      <thead>
                        <td class="headerCell center" colspan="7">Ext Warranties</td>
                      </thead>
                      @for (warranty of this.extWarranties(); track warranty) {
                        <tr>
                          <td class="tableCell">{{ warranty.warrantyTitle }}</td>
                          <td class="tableCell">{{ warranty.warrantyDesc }}</td>
                        </tr>
                      }
                    </table>
                  </div>
                }
                @if (this.sewpWarranties() && this.sewpWarranties().length > 0) {
                  <div class="tableContainer">
                    <table class="resultTable">
                      <thead>
                        <td class="headerCell" colspan="7">SEWP Warranties</td>
                      </thead>
                      <tr>
                        <td class="headerCell tableCell">Start Date</td>
                        <td class="headerCell tableCell">End Date</td>
                        <td class="headerCell tableCell">Part #</td>
                        <td class="headerCell tableCell">Description</td>
                      </tr>
                      @for (sewpWarranty of this.sewpWarranties(); track sewpWarranty) {
                        <tr>
                          <td class="tableCell">{{ sewpWarranty.warrantyStartDate }}</td>
                          <td class="tableCell">{{ sewpWarranty.warrantyEndDate }}</td>
                          <td class="tableCell">{{ sewpWarranty.warrantyPart }}</td>
                          <td class="tableCell">{{ sewpWarranty.warrantyDescription }}</td>
                        </tr>
                      }
                    </table>
                  </div>
                }
              </mat-tab>
            }
            @if (this.warrantyClaims() && this.warrantyClaims().length > 0) {
              <mat-tab label="Warranty Claims">
                <div class="tableContainer">
                  <table class="resultTable">
                    <tr>
                      <td class="headerCell tableCell">Part #</td>
                      <td class="headerCell tableCell">Description</td>
                      <td class="headerCell tableCell">Qty</td>
                      <td class="headerCell tableCell">Sales Order</td>
                      <td class="headerCell tableCell">Warranty Defect</td>
                      <td class="headerCell tableCell">Warranty Date</td>
                      <td class="headerCell tableCell">Labor Allowance</td>
                    </tr>
                    @for (warrantyClaim of this.warrantyClaims(); track warrantyClaim) {
                      <tr>
                        <td class="tableCell">{{ warrantyClaim.part }}</td>
                        <td class="tableCell">{{ warrantyClaim.descp }}</td>
                        <td class="tableCell">{{ warrantyClaim.quantity }}</td>
                        <td class="tableCell">{{ warrantyClaim.salesOrder }}</td>
                        <td class="tableCell">{{ warrantyClaim.warrantyDefect }}</td>
                        <td class="tableCell">{{ warrantyClaim.warrantyDate }}</td>
                        <td class="tableCell rightAligned">{{ warrantyClaim.laborAllowance | currency: "USD" }}</td>
                      </tr>
                    }
                  </table>
                </div>
              </mat-tab>
            }
          </mat-tab-group>
        }
        @if (errorMessage()) {
          <div class="errorMessage">
            {{ errorMessage() }}
          </div>
        }
        @if (isBusy()) {
          <div class="busyIndicator">
            <div class="busyContents">
              <mat-progress-spinner class="busySpinner" diameter="48" mode="indeterminate"></mat-progress-spinner>
              <label class="busyLabel" [innerHTML]="waitMessage()"></label>
            </div>
          </div>
        }
      </mat-dialog-content>
      <div mat-dialog-actions>
        @if (warranty() && partSerialInformation() && tabIndex == 0) {
          <div>
            <span>Can't find your part? Browse all parts</span>
            @if (partWithinPartErrorMessage()) {
              <span class="errorMessage">{{ partWithinPartErrorMessage() }}</span>
            }
            <br />
            <input
              class="standardTextBox searchInput"
              placeholder="Search by part number"
              [formControl]="allPartsSearchInputControl"
              (keyup)="handleAllPartsKeyUp($event)"
              [matAutocomplete]="auto" />
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
              @for (option of filteredOptions() | async; track option) {
                <mat-option [value]="option">{{ option.description }}</mat-option>
              }
            </mat-autocomplete>
            <button [disabled]="!this.allPartsSearchInputControl.value || this.allPartsSearchInputControl.value.length < 3" class="standardButton" (click)="allPartsSearch()">
              Search
            </button>
          </div>
        }
        <span class="spacer"></span>
        <span>
          <button class="warn-button" matButton="elevated" (click)="cancel()">Cancel</button>
          <button class="primary-button" matButton="elevated" [disabled]="cannotCreateQuote()" (click)="saveAndClose()">{{ isAddQuote() ? "Create Quote" : "Add parts" }}</button>
        </span>
      </div>
    </div>
  </div>
</form>
